import {Component} from '@angular/core';
import {AngularTokenService} from '@lakshvairav/angular-token';
import {Router} from '@angular/router';
import {AuthorizationService} from '../../../shared/authorization.service';
import {KeyValue} from '../../../shared/key-value';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'help-popup-yourbank',
  templateUrl: 'help-popup-yourbank.component.html'
})

export class HelpPopupYourbankComponent {
constructor(private router: Router, private _tokenService: AngularTokenService,
public authService: AuthorizationService, private KeyValueService: KeyValue) {

}

}
